export const preInductionAnesthesia = {
	identification: false,
	surgery_location: false,
	removal_of_adornments: false,
	fasting: false,
	informed_and_signed_terms: false,
	presence_of_companion: false,
	blood_reserve: "",
	pre_anesthetic_evaluation_performed: "",
	allergic_patient: "",
	patient_oriented_and_prepared: "",
	pulse_oximeter_installed: "",
	exams_available: "",
	difficult_airway: "",
	monitoring_installed: "",
	anesthetic_equipment_check: "",
	responsible_professional_id: "",
	performed_trichotomy: "",
	rapid_hiv_and_syphilis_test_performed: "",
};
